import { SIZES, ICON_SIZES } from 'common/constants/sizes';
import styled from 'styled-components';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';

export const StyledTeamNameCell = styled.div`
  display: flex;
  align-items: center;
  font-size: ${SIZES.medium};
  ${({ cursor }) => (cursor ? `cursor: ${cursor};` : '')}
  &.name {
    & .avatar {
      margin-right: 1rem;
    }
    & > svg {
      margin-left: 1rem;
    }
  }
  &.options {
    display: flex;
    justify-content: flex-end;
    & svg {
      cursor: pointer;
      margin-left: 1rem;
      &:hover {
        opacity: 0.7;
      }
    }
  }
`;

export const StyledMembersCell = styled.div``;

export const StyledCycleTimeCell = styled(Flex)`
  width: 10rem;
  justify-content: end;
`;

export const StyledCell = styled.div``;

export const StyledTitle = styled(Text)`
  text-transform: uppercase;
  font-size: 1.4rem;
  font-weight: 500;
  color: ${getColor('abbey')};
`;

export const StyledMetricsBenchmarkIcon = styled(Flex)`
  align-items: center;
  ${({ size }) => `width: ${ICON_SIZES[size]}; height: ${ICON_SIZES[size]};`}
`;

export const StyledBlankTrendIcon = styled(Flex)`
  align-items: center;
  ${({ paddingLeft }) => `padding-left: ${paddingLeft || '1.5rem'};`}
  width: 8px;
  height: 13px;
`;
